import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicFeaturedStores {
  constructor(section) {
    this.el = section.el;
    this.splide = null;
    this._init();
  }

  _init() {
    this.splide = initCarousel(
      this.el,
      {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        arrows: true,
        pagination: true,
        padding: {
          right: '10%',
        },
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            destroy: true,
          },
        },
      },
      true,
    );
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
